import { devicesQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useDeleteAllDevices() {
  const toast = useToast();
  const { t } = useI18n();

  return useNosIdMutation({
    mutationFn: async ({ devices, sa }: { sa: string; devices: string[] }) => {
      return Promise.all(
        devices.map((id) =>
          api.delete('/api/v1/device-management/:accountId/devices/:deviceId', {
            params: { accountId: sa, deviceId: id },
          }),
        ),
      );
    },
    successLogAction: () => ({ ActionType: ActionType.DeviceManagement }),
    errorLogAction: () => ({ ActionType: ActionType.DeviceManagement }),
    onSuccess: (_payload, { sa, devices }, _result, { client }) => {
      client.setQueryData(devicesQueryOptions(sa).queryKey, (old) =>
        old?.filter((device) => !devices.includes(device.Id)),
      );
      toast.show('success', t('Common.SnackBar.AllDevicesRemoved'));
    },
  });
}
